module.exports = __webpack_public_path__ + "img/post_pic3.cc186f7b.png";